// extracted by mini-css-extract-plugin
export default {"DraggablePostCard":"DraggablePostCard_DraggablePostCard__8J7rH","DragStatePlaceholder":"DraggablePostCard_DragStatePlaceholder__d0Myq"};